window.uc_googlemaps = false;
window.uc_kies_ad_ref = false;
window.uc_kies_ad_et = false;
window.ytAllowed = false;

window.dataLayer = window.dataLayer || [];
window.uetq = window.uetq || [];
window.uetq.push('consent', 'default', {'ad_storage': 'denied'});

export class CookieConsent {

  static init() {
    // set initial consents
    window.dataLayer.forEach((data) => {
      if (data.event === 'consent_status') {
        console.info('Initial Consent');
        window.uetq.push('consent', 'update', {'ad_storage': data['Microsoft Advertising'] ? 'granted' : 'denied'});

        window.uc_kies_ad_ref = data['Kieser Training (kies_ad_ref)'];
        window.uc_kies_ad_et = data['Kieser Training (kies_ad_et)'];

        window.uc_googlemaps = data['Google Maps'];
        window.ytAllowed = data['YouTube Video'];

        CookieConsent.initConsentModules();
      }
    });

    window.addEventListener('ucEvent', function (e) {
      console.info('Consent has changed');
      if (e.detail && e.detail.event === 'consent_status') {
        window.uetq.push('consent', 'update', {'ad_storage': e.detail['Microsoft Advertising'] ? 'granted' : 'denied'});

        window.uc_kies_ad_ref = e.detail['Kieser Training (kies_ad_ref)'];
        window.uc_kies_ad_et = e.detail['Kieser Training (kies_ad_et)'];

        window.uc_googlemaps = e.detail['Google Maps'];
        window.ytAllowed = e.detail['YouTube Video'];
        CookieConsent.initConsentModules();
      }
    });
  }

  static initConsentModules () {
    // set kieser cookies
    if(window.uc_kies_ad_ref) {
      import('./kies_ad_ref').then(module => {
        module.default();
      })
    }
    if(window.uc_kies_ad_et) {
      import('./kies_ad_et').then(module => {
        module.default();
      })
    }

    const studioFinder = document.getElementById('studio-finder');
    if(!!studioFinder) {

      import('../components/studio-finder/app').then(module => {
        module.default();
      })
    }

    /* Studio Detail Pages */
    const review = document.getElementById('review__slider');
    if(!!review) {
      import('../components/google-maps/reviews').then(module => {
        module.default(review);
      })
    }
    const studioLocation = document.getElementById('studio-location');
    if(!!studioLocation) {
      import('../components/google-maps/studio-location').then(module => {
        module.default(studioLocation);
      })
    }
    const studioStreetview = document.getElementById('studio-streetview');
    if(!!studioStreetview) {
      import('../components/google-maps/studio-streetview').then(module => {
        module.default(studioStreetview);
      })
    }

    const videos = document.querySelectorAll('.video');
    if (videos.length > 0) {
      videos.forEach((vi) => {
        const consent = vi.querySelector('.info-box');

        if(!!consent) {
          if(window.ytAllowed) {
            consent.classList.add('d-none');
          } else {
            consent.classList.remove('d-none');
          }
        }

        import('../components/video-translation').then(module => {
          module.default(vi);
        });
      });
    }
  }
}